/*
 * Update an vpp_r_t with either status or notes or both
 * this follows a simple mutation pattern, where changed values will be patched, but we won't update the
 *   retrieved store.  This assumes that upon update, the edit experience exits, and programs are re-retreved.
 */
import graphql from 'babel-plugin-relay/macro';
import { commitMutation } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment';

  const abEnvironment = new AbEnvironment();
  const mutation = graphql`
  mutation VppRTUpdateMutation($input: UpdateVppRTByVpprIdInput!) {
    updateVppRTByVpprId(input: $input) {
      vppRT {
        vpprId
        stage
      }
    }
  }
  `;
    
  function commit(vpprId, stage, notes, firstName, lastName, email) {
    var variables = {
        input: {
          vpprId,
          vppRtPatch: {}
        }
    };

    if (stage != null)
        variables.input.vppRtPatch.stage = stage;
    if (notes != null)
        variables.input.vppRtPatch.notes = notes;

    //these columns are nullable; if empty string, write as null (null or undefined are not intentional states from user)
    if (firstName != null) {
      if (firstName === '') {
        variables.input.vppRtPatch.repFname = null;
      } else {
        variables.input.vppRtPatch.repFname = firstName;
      }
    }
    if (lastName != null) {
      if (lastName === '') {
        variables.input.vppRtPatch.repLname = null;      
      } else {
        variables.input.vppRtPatch.repLname = lastName;
      }
    }
    if (email != null) {
      if (email === '') {
        variables.input.vppRtPatch.repEmail = null;
      } else {
        variables.input.vppRtPatch.repEmail = email;
      }
    }
    
    return new Promise((resolve, reject) => {
      commitMutation(
        abEnvironment.getEnvironment(), {
        mutation,
        variables,
        onCompleted: (response) => {
          resolve(response);
        },
        onError: (error) => {
          reject(error);
        }
      });
    });
  }
  /* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
  export default { commit };
 